export abstract class OembedProviderInterface {
  abstract name: string;
  abstract urls: RegExp[];

  abstract getVideo(url: string): string;

  getId(url: string): string | null {
    const matches = this.urls
      .map((pattern) => {
        // 1. Try to match without stripping the protocol and "www" subdomain.
        let match = url.match(pattern);

        if (match) {
          return match[1];
        }

        // 2. Try to match after stripping the protocol.
        let rawUrl = url.replace(/^https?:\/\//, '');
        match = rawUrl.match(pattern);

        if (match) {
          return match[1];
        }

        // 3. Try to match after stripping the "www" subdomain.
        rawUrl = rawUrl.replace(/^www\./, '');
        match = rawUrl.match(pattern);

        if (match) {
          return match[1];
        }

        return null;
      })
      .filter((id) => id !== null);

    return matches && matches.length > 0 ? matches[0] : null;
  }
}
